import React from 'react';

import utcToZonedTime from 'date-fns-tz/utcToZonedTime';
import { useIntl } from 'react-intl-next';

import { NowLocation } from '../../../../utils/constants/schedule';
import { getNowLocation } from '../../../../utils/schedule';

import { Cell, Container, EmptyTime, Header, Inner, Line, List, Stripe, Time } from './styled';
import { type LayerProps } from './types';
import { generateDateStrings, generateRanges, getTimeDisplay } from './utils';

// TODO: add Gaps
const Layer = ({
	nowEpoch,
	startEpoch,
	endEpoch,
	offset,
	size,
	variant,
	rotationSlot,
}: LayerProps): JSX.Element => {
	const intlApi = useIntl();

	const display = getTimeDisplay(startEpoch, endEpoch);

	const ranges = generateRanges({
		startEpoch,
		endEpoch,
		offset,
	});

	const nowInRange = getNowLocation(startEpoch, endEpoch, nowEpoch) === NowLocation.InRange;

	return (
		<Container>
			{ranges.map(([start, end], i) => (
				<Line
					variant={variant}
					ratio={100 / ranges.length}
					index={i}
					key={`line-${start.valueOf()}-${end.valueOf()}`}
				/>
			))}

			<Header aria-hidden>
				{variant === 'full' && <EmptyTime />}

				<Inner>
					{ranges.map(([start, end]) => {
						const [first, second] = generateDateStrings({
							intlApi,
							display,
							date: start,
						});

						return (
							<Cell
								variant={variant}
								ratio={100 / ranges.length}
								display={display}
								key={`cell-${start.valueOf()}-${end.valueOf()}`}
								nowLocation={getNowLocation(
									start.valueOf(),
									end.valueOf(),
									utcToZonedTime(nowEpoch + offset, 'UTC').valueOf(),
								)}
							>
								<Time data-testid="first-time" display={display}>
									{first}
								</Time>
								<Time data-testid="second-time" display={display}>
									{second}
								</Time>
							</Cell>
						);
					})}
				</Inner>
			</Header>

			{nowInRange && (
				<Stripe
					data-testid="indicator"
					nowEpoch={nowEpoch}
					startEpoch={startEpoch}
					endEpoch={endEpoch}
					variant={variant}
				/>
			)}

			<List size={size}>{rotationSlot}</List>
		</Container>
	);
};

export { Layer };
